import { clamp01, lerp, smoothstep01 } from '@/lib/utils/math'

const HEADLINE_TEXT = 'Do ateliê até a porta.'
const BODY_TEXT =
  'Entregamos em toda a cidade — do centro aos bairros mais distantes.'
const NOTE_TEXT = 'Combine a entrega por e-mail.'

const ENTER_END = 0.28
const EXIT_START = 0.82

export interface DeliverySectionModelProps {
  progress: number
}

export function useDeliverySectionModel({
  progress,
}: DeliverySectionModelProps) {
  const enter = smoothstep01(progress / ENTER_END)
  const exit = smoothstep01((progress - EXIT_START) / (1 - EXIT_START))
  const opacity = clamp01(enter * (1 - exit))

  return {
    headlineText: HEADLINE_TEXT,
    bodyText: BODY_TEXT,
    noteText: NOTE_TEXT,
    stageInert: progress <= 0 || progress >= 1,
    blockStyle: {
      opacity: Math.round(opacity * 1000) / 1000,
      transform: `translate3d(0, ${lerp(34, -6, enter).toFixed(2)}px, 0)`,
    },
  }
}
